<template>
  <div class="article">
    <div v-html="terms.body" />
  </div>
</template>

<script>
import ApiRequestor from '../common/ApiRequestor'
export default {
  name: "RaTerms",
  data: function () {
    return {
      message: "",
      terms: {
        title: '',
        body: ''
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      ApiRequestor.get('ra_term/articles/latest').then(
        response => {
          this.terms = response.data
        },
        error => {
          this.message = error.response.data
        }
      );
    }
  }
}
</script>